const NDS_PENCILED_KEY = 'ndsPenciledListings';
function getPenciledListings() {
  try {
    const stored = localStorage.getItem(NDS_PENCILED_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}
function addPenciledListing(listingId) {
  const listings = getPenciledListings();
  if (!listings.includes(listingId)) {
    listings.push(listingId);
    try {
      localStorage.setItem(NDS_PENCILED_KEY, JSON.stringify(listings));
    } catch {
      // Ignore storage errors
    }
  }
}
export { addPenciledListing, getPenciledListings };
